import PropTypes from 'prop-types';
import Select from 'react-select';

const DropDownSelector = ({ items, selectedItem, setSelectedItem }) => {
  const customStyles = {
    control: (base) => ({
      ...base,
      borderRadius: '0.5rem',
      border: '1px solid var(--color-pj-primary-200)',
      '&:hover': {
        border: '1px solid var(--color-pj-primary-400)',
      },
      boxShadow: 'none',
      fontSize: '1.2rem',
      padding: '0.45rem',
      cursor: 'pointer',
    }),
    option: (base, state) => ({
      ...base,
      padding: 10,
      backgroundColor: state.isFocused
        ? 'var(--color-pj-primary-200)'
        : 'transparent',
      color: 'var(--color-pj-gray-800)',
      cursor: 'pointer',
      fontSize: '1.2rem',
    }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--color-pj-gray-800)',
      fontSize: '1.2rem',
    }),
    placeholder: (base) => ({
      ...base,
      color: 'var(--color-pj-gray-600)',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };

  return (
    <Select
      options={items}
      styles={customStyles}
      onChange={(item) => setSelectedItem(item)}
      value={selectedItem}
    />
  );
};

DropDownSelector.propTypes = {
  selectedItem: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  setSelectedItem: PropTypes.func.isRequired,
};

export default DropDownSelector;
